<!-- =========================================================================================
    File Name: ChartPieChart.vue
    Description: Create pie chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="" class="mb-base">

        <div class="mt-5">
            <chartjs-component-pie-chart :height=250 v-if="loaded" :data="data" :options="options"></chartjs-component-pie-chart>
        </div>

        <template slot="codeContainer">

        </template>
    </vx-card>
</template>

<script>
import ChartjsComponentPieChart from "./charts-components/ChartjsComponentPieChart.vue"
import BASE from '../../../../vue.config.js'

export default {
    data() {
          return {
            loaded: false,
            data:null,
            options: null
        }
    },

     methods: {

        ObtenerInscripcionesMensuales(){
            
            var arrMeses = [];
            var arrTotales = [];

            fetch(`${BASE.baseUrl}api/ReporteInscripcionesMensuales`, {
                method: 'GET',
                headers: {'Authorization': sessionStorage.getItem('token')}
            })
            .then(rs => rs.json())
            .catch(error => console.log('error:', error))
            .then(rs => {
                if(rs.status == 200){

                    this.loaded = true;
                    rs.result.forEach((item, index) => {
                        arrMeses.push(item.fecha);
                        arrTotales.push(item.totalInscripcion);
                    });

                    this.data =  {
                        labels: arrMeses, 
                        datasets: [{
                            label: "Total",
                            backgroundColor: ["#3e95cd", "#8e5ea2", "#3cba9f", "#e8c3b9", "#c45850", "#1E1E1E","#3e95cd"],
                            data: arrTotales, 
                        }]
                    },
                     this.options = {
                       legend: { display: true },
                        title: {
                            display: true,
                             text: 'Total Inscripciones por mes (6 meses)'
                        }
                    }
                }
              });
        },

    },
    components: {
        ChartjsComponentPieChart
    },
      mounted(){
       this.ObtenerInscripcionesMensuales();
    },
}
</script>